export async function asyncProps(obj: Record<string, Promise<unknown>>): Promise<Record<string, unknown>> {
  const values = await Promise.all(Object.values(obj));
  return Object.keys(obj).reduce(
    (out, key, index) => ({
      ...out,
      [key]: values[index]
    }),
    {}
  );
}

export async function sequentialPromise<T, Return>(list: T[], fn: (item: T) => Promise<Return>): Promise<Return[]> {
  const results = [];

  for (const item of list) {
    // eslint-disable-next-line no-await-in-loop
    results.push(await fn(item));
  }

  return results;
}
